import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { RouteResolver } from 'components';
import { useFederationInit } from 'hooks';


function App() {
  const { loading, routes, versions } = useFederationInit();
  if (loading) {
    return null
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<RouteResolver routes={routes} versions={versions} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
